export const NAV_4_MAIN_CONTENT_ID = 'AkMainContent';
